import { Logger } from '@nvision/services/logger';

import { services as oidcServices } from '@nvision/identity-core';

export const APP_VERSION_KEY = 'appVersion';

const logger = new Logger({ prefix: 'version sync with local storage' });

export const guardAppVersion = (currentVersion: string): void => {
  try {
    const storedVersion = localStorage.getItem(APP_VERSION_KEY);

    if (!storedVersion || storedVersion !== currentVersion) {
      oidcServices.auth.enableOIDCProvider();
      localStorage.setItem(APP_VERSION_KEY, currentVersion);
      window.location.reload();
    }
  } catch (error) {
    logger.error('Guard version error:', error);
  }
};
